export const fileExportNamesMixin = {
  computed: {
    fileExportnames() {
      return this.$store.getters['uiconfig/fileExportNames']
    },
  },
  methods: {
    getTenantName(id) {
      if (!this.fileExportNames || !this.fileExportNames[id]) {
        return
      }
      return this.fileExportNames[id].FileExportTenantName
    },
    getProjectName(id) {
      if (!this.fileExportNames || !this.fileExportNames[id]) {
        return
      }
      return this.fileExportNames[id].FileExportProjectName
    },
  },
}